<template>
  <div id="app" :class="appClass">
    <!-- Page Wrapper -->
    <Login v-if="!loggedIn" />
    <MissingRole v-if="missingAuthorization" />
    <div id="wrapper" v-if="hasAccess">
      <Sidebar :collapsed="sidebarCollapsed" />
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">
        <!-- Main Content -->
        <div id="content">
          <Navbar v-if="hasAccess" @toggle-sidebar="toggleSidebar" />
          <!-- Begin Page Content -->
          <div class="container-fluid">
             <ToastHost />
            <router-view v-if="hasAccess" />
          </div>
        </div>
        <AppFooter />
      </div>
    </div>
  </div>
</template>

<script>
  import ToastHost from "@/components/common/ToastHost.vue";
import Sidebar from "@/components/frame/Sidebar.vue";
import Navbar from "@/components/frame/Navbar.vue";
import AppFooter from "@/components/frame/Footer.vue";
import Login from "@/components/frame/Login.vue";
import MissingRole from "@/components/frame/MissingRole.vue";
import { AuthenticationContext } from "@/auth/msal-context";

import { GET_EVENTS } from "@/store/action-types";
import { EVENT_NAMESPACE } from "@/store/namespace-types";

export default {
  components: {
    Sidebar,
    AppFooter,
    Navbar,
    Login,
    MissingRole,
    ToastHost
  },
  data() {
    return {
      sidebarCollapsed: false,
    };
  },
  watch: {
    loggedIn: function(newVal, oldVal) {
      if (newVal === true && newVal != oldVal) {
        this.loadEvents();
      }
    },
  },
  methods: {
    loadEvents() {
      this.$store.dispatch(EVENT_NAMESPACE + "/" + GET_EVENTS);
    },
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
    },
  },
  created() {
    this.loadEvents();
  },
  computed: {
    loggedIn() {
      return AuthenticationContext.isAuthenticated();
    },
    missingAuthorization(){
      if(this.loggedIn){
        return !AuthenticationContext.checkRoles(['Admin', 'Vorstand', 'Users'])
      }
      return true;
    },
    hasAccess(){
      return this.loggedIn &&  !this.missingAuthorization
    },
    appClass() {
      if (this.loggedIn) {
        return "";
      }
      return "bg-gradient-primary";
    },
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
